<div class="content">
  <app-header></app-header>
  <app-loader></app-loader>
  <div class="page">
    <app-forgot-password></app-forgot-password>
  </div>
</div>
<app-footer></app-footer>
